module.exports = __webpack_public_path__ + "static/media/21ECLAC15.6da0ac06.jpg";